export default function LoadingDeveloperApplications() {
  return (
    <div className='flex flex-col w-full animate-pulse'>
      <div className='bg-white shadow overflow-hidden sm:rounded-md w-full'>
        <ul role='list' className='divide-y divide-gray-200'>
          {[1, 2, 3, 4, 5].map((num) => (
            <li key={num}>
              <div className='flex items-center px-4 py-4 sm:px-6'>
                <div className='min-w-0 flex-1 flex items-center'>
                  <div className='min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4'>
                    <div className='hidden md:block'>
                      <div>
                        <p className='text-sm h-2 w-1/5 bg-neutralColor-light rounded-md'></p>
                        <div className='mt-2 text-sm text-gray-500 space-y-2'>
                          <p className='text-sm h-2 w-1/4 bg-neutralColor-light rounded-md'></p>
                          <p className='text-sm h-2 w-1/3 bg-neutralColor-light rounded-md'></p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p className='h-2 w-1/5 bg-neutralColor-light rounded-md'></p>
                      <p className='mt-2 h-2 w-1/4 bg-neutralColor-light rounded-md'></p>
                      <p className='mt-2 h-2 w-1/4 bg-neutralColor-light rounded-md'></p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
